import React from 'react';
import GlobalDispatchContext from './GlobalDispatchContext';
import GlobalStateContext from './GlobalStateContext';
import {
	globalReducer,
	TOGGLE_MENU_STATE,
	TOGGLE_MENU_UPDATE,
	OPEN_ACCORDION_ITEM,
} from './globalReducer';

const globalInitialState = {
	menuOpened: true,
	menuToggleProgress: 0,
	menuSelectedAnchor: '*',
};

export const GlobalProvider = (props) => {
	const [state, dispatch] = React.useReducer(globalReducer, globalInitialState);

	const toggleMenuState = (menuOpened = true) => {
		dispatch({ type: TOGGLE_MENU_STATE, menuOpened });
	};

	const toggleMenuUpdate = (menuToggleProgress = 0) => {
		dispatch({ type: TOGGLE_MENU_UPDATE, menuToggleProgress });
	};

	const openAccordionItem = (menuSelectedAnchor = '*') => {
		dispatch({ type: OPEN_ACCORDION_ITEM, menuSelectedAnchor });
	};

	return (
		<GlobalDispatchContext.Provider
			value={{
				toggleMenuState,
				toggleMenuUpdate,
				openAccordionItem,
			}}
		>
			<GlobalStateContext.Provider value={state}>
				{props.children}
			</GlobalStateContext.Provider>
		</GlobalDispatchContext.Provider>
	);
};

export default GlobalProvider;
